import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { ResourcesService } from 'app/services/resources.service';
import { IpLocationService } from 'app/wipperoz-core/services/ip-location.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { forkJoin, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-wipperoz-services',
  templateUrl: './wipperoz-services.component.html',
  styleUrls: ['./wipperoz-services.component.scss']
})
export class WipperozServicesComponent implements OnInit, OnDestroy {
  categories = [];
  isLoading = true;
  teamSlides: OwlOptions = {
    loop: true,
    nav: false,
    dots: false,
    autoplayHoverPause: true,
    autoplay: true,
    margin: 30,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      },
      1500: {
        items: 5
      }
    }
  };
  private unsubscribeAll: Subject<any>;

  constructor(
    private resourcesService: ResourcesService,
    private ipLocationService: IpLocationService,
    @Inject(LOCALE_ID) public localeId: string
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  private init(): void {
    forkJoin([this.ipLocationService.getLocation().toPromise(), this.resourcesService.getUserStatistics()])
      .toPromise()
      .then((data) => {
        const locationLatUser = data[0].items[0].locationData.location.latitude;
        const locationLngUser = data[0].items[0].locationData.location.longitude;

        const suppliersData = data[1];

        suppliersData.items.map((e) => {
          if (this.localeId === 'es') {
            e.categoryTitle = e.categoryEs;
          } else {
            e.categoryTitle = e.categoryEn;
          }
          if (e.lat === undefined) {
            if (this.localeId === 'es') {
              e.categorySubtitle = 'En linea';
              e.thumbnailImage = e.contentEs.thumbnailImage;
              e.slug = e.contentEs.slug;
            } else {
              e.categorySubtitle = 'Online';
              e.thumbnailImage = e.contentEn.thumbnailImage;
              e.slug = e.contentEn.slug;
            }
            this.categories.push(e);
          } else {
            if (this.localeId === 'es') {
              e.categorySubtitle = e.contentEs.title.substring(
                e.contentEs.title.indexOf(' en ') + 4,
                e.contentEs.title.length
              );
              e.thumbnailImage = e.contentEs.thumbnailImage;
              e.slug = e.contentEs.slug;
            } else {
              e.categorySubtitle = e.contentEn.title.substring(
                e.contentEn.title.indexOf(' in ') + 4,
                e.contentEn.title.length
              );
              e.thumbnailImage = e.contentEn.thumbnailImage;
              e.slug = e.contentEn.slug;
            }

            const locationLatSupplier = e.lat;
            const locationLngSupplier = e.lng;

            const distanceToSupplier = this.distanceToSupplier(
              locationLatUser,
              locationLngUser,
              locationLatSupplier,
              locationLngSupplier
            );

            if (distanceToSupplier <= 3000) {
              this.categories.push(e);
            }
          }
        });
        this.isLoading = false;
      });
  }

  private distanceToSupplier(latUser, lngUser, latSupplier, lngSupplier) {
    return this.getDistanceFromLatLonInKm(latUser, lngUser, latSupplier, lngSupplier);
  }
  private getDistanceFromLatLonInKm(lat1, lng1, lat2, lng2) {
    const earthRadius = 6371;
    const differenceLat = this.deg2rad(lat2 - lat1);
    const differenceLng = this.deg2rad(lng2 - lng1);
    const tmp =
      Math.sin(differenceLat / 2) * Math.sin(differenceLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(differenceLng / 2) *
        Math.sin(differenceLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(tmp), Math.sqrt(1 - tmp));
    const distance = earthRadius * c;
    return Math.round(distance);
  }

  private deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
}
